import type { AxiosInstance } from 'axios';
import axios from 'axios';
import type { IContactFormSubmissionRequest } from '../../domain';

export class ContactFormSubmissionService {
    instance: AxiosInstance;

    constructor() {
        // todo: get baseURL from ENV variable
        this.instance = axios.create({
            baseURL: '/api-gtw-noauth',
            headers: { 'x-requested-with': 'PortalContactForm', 'content-type': 'application/json' },
        });
    }

    async submitContactForm(bankId: number, request: IContactFormSubmissionRequest) {
        return this.instance.post<IContactFormSubmissionRequest>(`/crm-services/bsi/api/${bankId}/v1/contactform`, request).then((response) => response.data);
    }
}
